import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import useAuthStore from '../store/auth-store'
import { Hero } from '../components/Hero'
import { About } from '../components/About'
import { Features } from '../components/Features'
import { DemoProjects } from '../components/DemoProjects'
import { Plans } from '../components/Plans'
import { CTA } from '../components/CTA'
import { Footer } from '../components/Footer'
import { Navigation } from '../components/Navigation'

export function HomePage() {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuthStore()

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard')
    }
  }, [isAuthenticated, navigate])

  return (
    <div className="w-full">
      <Navigation />
      <Hero />
      <About />
      <Features />
      <DemoProjects />
      <Plans />
      <CTA />
      <Footer />
    </div>
  )
}
